import styles from './BillBlock.module.scss';
import { useTranslation } from 'react-i18next';

interface Props {
  bill_id: number | null;
}

const BillBlock = ({ bill_id }: Props) => {
  const { t } = useTranslation();

  return (
    <label className={styles.containerBlock}>
      <span className={styles.labelText}>BillID</span>
      <span className={styles.name}>{!!bill_id ? bill_id : t('empty')}</span>
    </label>
  );
};

export default BillBlock;
